var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'color': _vm.color})},[_c('el-icon',{staticClass:"el-icon-warning-outline"}),_c('span',[_vm._v(" "+_vm._s(_vm.placeholder))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }